<!-- Nova versão (pills + select) — quando isNewHomePedirDelivery -->
<ng-container *ngIf="isNewHomePedirDelivery">
	<div *ngIf="!stickyMode" #pillsWrapper class="category-pills-wrapper">
		<div class="category-pills">
			<button
				*ngIf="!itemsToHide?.featuredItems"
				type="button"
				class="category-pill"
				[class.category-pill--active]="categoryToScroll === 'featuredItems'"
				(click)="selectCategory('featuredItems')"
			>{{ 'On Sale' | translate }}</button>
			<button
				*ngIf="!itemsToHide?.combos"
				type="button"
				class="category-pill"
				[class.category-pill--active]="categoryToScroll === 'combos'"
				(click)="selectCategory('combos')"
			>{{ comboCategoryName }}</button>
			<button
				*ngIf="!itemsToHide?.pizzas"
				type="button"
				class="category-pill"
				[class.category-pill--active]="categoryToScroll === 'pizzas'"
				(click)="selectCategory('pizzas')"
			>{{ pizzaCategoryName }}</button>
			<ng-container *ngFor="let category of categories; trackBy: trackById">
				<button
					*ngIf="showCategory(category.products)"
					type="button"
					class="category-pill"
					[class.category-pill--active]="categoryToScroll === (category.name + '-' + category.id)"
					(click)="selectCategory(category.name + '-' + category.id)"
				>{{ category.name }}</button>
			</ng-container>
		</div>
	</div>

	<!-- Select (quando a barra está fixa no topo) -->
	<div *ngIf="stickyMode" class="category-select-wrapper">
		<select
			class="category-select"
			[id]="selectId"
			[(ngModel)]="categoryToScroll"
			(change)="onSelectChange($event)"
		>
			<option value="scroll-to-top">↑ {{ 'Back to top' | translate }}</option>
			<option *ngIf="!itemsToHide?.featuredItems" value="featuredItems">{{ 'On Sale' | translate }}</option>
			<option *ngIf="!itemsToHide?.combos" value="combos">{{ truncate(comboCategoryName) }}</option>
			<option *ngIf="!itemsToHide?.pizzas" value="pizzas">{{ truncate(pizzaCategoryName) }}</option>
			<ng-container *ngFor="let category of categories; trackBy: trackById">
				<option *ngIf="showCategory(category.products)" [value]="category.name + '-' + category.id">{{ truncate(category.name) }}</option>
			</ng-container>
		</select>
	</div>
</ng-container>

<!-- Original (master): ion-segment — sem wrapper, sem novas classes -->
<ng-container *ngIf="!isNewHomePedirDelivery">
	<ion-segment id="categoryNav" class="sticky" color="danger" mode="md" scrollable (ionChange)="changeCategory($event)" [(ngModel)]="categoryToScroll">
		<ion-segment-button *ngIf="!itemsToHide.featuredItems" value="featuredItems" id="featuredItems-category" (click)="selectedCategory = 'featuredItems'; categoryToCentralizeInNav = 'featuredItems-category'; reselectSegment('featuredItems')">
			<ion-label>{{ 'On Sale' | translate }}</ion-label>
		</ion-segment-button>
		<ion-segment-button *ngIf="!itemsToHide.combos" value="combos" id="combos-category" (click)="selectedCategory = 'combos'; categoryToCentralizeInNav = 'combos-category'; reselectSegment('combos')">
			<ion-label>{{ comboCategoryName }}</ion-label>
		</ion-segment-button>
		<ion-segment-button *ngIf="!itemsToHide.pizzas" value="pizzas" id="pizzas-category" (click)="selectedCategory = 'pizzas'; categoryToCentralizeInNav = 'pizzas-category'; reselectSegment('pizzas')">
			<ion-label>{{ pizzaCategoryName }}</ion-label>
		</ion-segment-button>
		<ng-container *ngFor="let category of categories; let i = index; trackBy: trackById">
			<ion-segment-button *ngIf="showCategory(category.products)" [value]="category.name + '-' + category.id" [id]="'general-' + category.id" (click)="selectedCategory = i; categoryToCentralizeInNav = 'general-' + category.id; reselectSegment(category.name + '-' + category.id)">
				<ion-label>{{ category.name }}</ion-label>
			</ion-segment-button>
		</ng-container>
	</ion-segment>
</ng-container>
